import { decodeBase64, stopPropagation } from '../lib/_tool.js';
export let nav = {
	register: function(){
		let $btnMenu 		= document.querySelector("[data-menu]");
		let $btnMenuClose 	= document.querySelector("[data-menu-close]");
		
		if($btnMenu){
			//single handlers
			const eventListeners = [
				{ element: $btnMenu, type: "click", handler: nav.checkMenu},
				{ element: $btnMenuClose, type: "click", handler: nav.toggleMenu}
			]
			eventListeners.forEach( ( el ) => {
				if(el.element){
					el.element.removeEventListener(el.type, el.handler, false);
					el.element.addEventListener(el.type, el.handler, false);
				}
			});
		}
		
		//複数ボタンがあるもの
		let $btnOpenModal 	= document.querySelectorAll("[data-modal-open]");
		let $btnCloseModal 	= document.querySelectorAll("[data-modal-close]");
		let $email 			= document.querySelectorAll("[data-address]");
		
		const multipleEventListeners = [
			{ element: $btnOpenModal, type: "click", handler: modal.open},
			{ element: $btnCloseModal, type: "click", handler: modal.close},
			{ element: $email, type: "click", handler: nav.sendMail}
		];
		multipleEventListeners.forEach( ( els ) => {
			if(els.element){
				els.element.forEach( (element) => {
					element.removeEventListener(els.type, els.handler, false);
					element.addEventListener(els.type, els.handler, false);
				})
				
			}
		});
		//console.log("common nav registered ---------------------------------------");
	},
	checkMenu: function(e){
		e.preventDefault();
		let $html = document.documentElement;
		let isPage = document.querySelector("main").getAttribute("data-page");
		if( isPage === "top" && !$html.classList.contains("u-show_menu") ){
			let currentY 	= window.pageYOffset;
			let $kv			= document.querySelector(".s-kv");
			let limitY		= $kv.clientHeight;
			if( currentY < limitY ){
				nav.callbackScrollTo(limitY, nav.toggleMenu);
			}else{
				nav.toggleMenu();
			}
		}else{
			nav.toggleMenu();
		}
	},
	toggleMenu: function(){
		let $html = document.documentElement;
		let $target = document.querySelector("#g-nav");
		if( !$html.classList.contains("u-show_menu") ){
			$html.classList.add("u-show_menu");
			$target.setAttribute("aria-hidden", false);
			document.removeEventListener("wheel", stopPropagation, false);
			document.addEventListener("wheel", stopPropagation, false);
		}else{
			$html.classList.remove("u-show_menu");
			$target.setAttribute("aria-hidden", true);
			document.removeEventListener("wheel", stopPropagation, false);
		}
	},
	sendMail: function(e){
		let address = this.getAttribute("data-address");
		let email 	= decodeBase64(address);
		let subject = "";
		let body 	= "";
		let mailtoLink = `mailto: ${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
		window.location.href = mailtoLink;
	},
	callbackScrollTo: function(position, callback){
		window.scrollTo({
			top: position,
			behavior: 'smooth'  // スムーズスクロールを指定
		});
		
		// スクロールの完了を監視
		const checkIfScrollFinished = () => {
			// 現在のスクロール位置が目的地に到達しているか確認
			if (Math.abs(window.scrollY - position) < 1) {
				if (callback && typeof callback === 'function') {
					callback(); // コールバックを実行
				}
			} else {
				requestAnimationFrame(checkIfScrollFinished); // まだスクロール中ならもう一度チェック
			}
		};
		
		requestAnimationFrame(checkIfScrollFinished); // 初回のチェックを開始
	}
}

/*
data-modal-open="modalのID"
data-active="true"がついたモーダルが立ち上がる
*/
let modal = {
	open: function(e){
		e.preventDefault();
		let $html 	= document.documentElement;
		let modalID = this.getAttribute("data-modal-open");
		let $modal 	= document.querySelector("#" + modalID);
		$modal.setAttribute("data-active", true);
		if( !$html.classList.contains("show_modal") ){
			$html.classList.add("show_modal");
		}
	},
	close: function(e){
		e.preventDefault();
		
		let $modal 	= document.querySelector(`dialog[data-active="true"]`);
		let $html 	= document.documentElement;
		if( $html.classList.contains("show_modal") ){
			$html.classList.remove("show_modal");
			setTimeout(function(){
				$modal.setAttribute("data-active", "");
			}, 200);
		}
	}
}